module.exports = __webpack_public_path__ + "img/bimb.1fc1b109.png";